import * as _ from 'lodash';
import * as moment from 'moment';
import ActionsApi from '@/api/ActionsApi';
import ACTIONS
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/current-month/components/action-list/actions.consts.ts';

const state = {
  actions: [],
};

const DEFAULT_ACTIONS = [
  {
    type: ACTIONS.SETUP_ACCOUNTS,
    order: 1,
  },
  {
    type: ACTIONS.FIRST_CF,
    order: 2,
  },
  {
    type: ACTIONS.FIXED_CHECK,
    order: 3,
  },
  {
    type: ACTIONS.SET_CHALLENGE,
    order: 4,
  },
  {
    type: ACTIONS.SET_RISEUP_GOAL,
    order: 5,
  },
  {
    type: ACTIONS.INVITE_MEMBER,
    order: 6,
  },
  {
    type: ACTIONS.GO_TO_CHAT,
    order: 7,
  },
  {
    type: ACTIONS.GO_TO_COMMUNITY,
    order: 8,
  },
];

const getters = {
  shouldShowActionsBadge: state => state.actions.length && moment(state.actions[0].created).add(1, 'month').isAfter(moment()),
};

const actions = {
  async fetchActions({ commit }, { isPositiveCf }) {
    const actions = await ActionsApi.fetchActions();
    if (actions && actions.length) {
      const allOrderedActions = _.chain(actions)
        .map(action => _.assign(action, _.find(DEFAULT_ACTIONS, a => a.type === action.type)))
        .orderBy(action => action.order)
        .value();
      const orderedActions = isPositiveCf ? allOrderedActions : _.reject(allOrderedActions, a => a.type === ACTIONS.SET_RISEUP_GOAL);
      commit('setActions', orderedActions);
    }
  },
  async markAsChecked({ commit }, { type }) {
    await ActionsApi.markAsChecked(type);
    const typeToMark = state.actions.find(action => action.type === type);
    typeToMark.checked = true;
    commit('setActions', [...state.actions]);
  },
};

const mutations = {
  setActions(state, actions) {
    state.actions = actions;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
